import tinycolor from "tinycolor2";

/**
 * Returns white/black color from the given color
 *
 * @param color
 * @returns
 */
export function getInvertColor(color: string) {
	// Range: 0 - 255
	// https://github.com/TinyCommunity/tinycolor2#getbrightness
	const tColor = tinycolor(color);
	return tColor.getBrightness() < 144 ? "#fff" : "#3C4255";
}

export function brightenColor(color: string, amount: number = 10) {
	const lighter = tinycolor(color).brighten(amount);
	return lighter.toHex8String();
}

export function isLightColor(color: string) {
	return tinycolor(color).isLight();
}
